import { toast } from 'sonner';

export function hasOpenToast(): boolean {
  return toast.getToasts().length > 0;
}
